import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { apiPut, formatDate } from '../utils/api';

const AdminForm = ({ admin, onClose, onSave }) => {
  const { print_lang } = useLanguage();

  const [formData, setFormData] = useState({
    name: admin?.name || '',
    status: admin?.status || 'active',
    license_expired: admin?.license_expired ? admin.license_expired.split('T')[0] : '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.name) {
      setError('Name is required');
      return;
    }

    setLoading(true);

    try {
      const result = await apiPut(`/api/admin/${admin.admin_id}`, formData);

      if (result.success) {
        onSave();
      } else {
        setError(result.message || 'Save failed');
      }
    } catch (err) {
      setError(err.message || 'Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{print_lang('admin.editAdmin', 'Edit Admin')}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="alert alert-error">{error}</div>}

            {admin.admin_id === 1 && (
              <div className="alert alert-info" style={{ marginBottom: '1rem' }}>
                <strong>Super Admin:</strong> This is the system super admin account.
              </div>
            )}

            <div className="form-group">
              <label className="form-label">{print_lang('admin.email', 'Email')}</label>
              <input
                type="email"
                className="form-input"
                value={admin.email}
                disabled
              />
              <small style={{ color: '#6b7280', fontSize: '0.75rem' }}>Email cannot be changed</small>
            </div>

            <div className="form-group">
              <label className="form-label">{print_lang('admin.name', 'Name')} *</label>
              <input
                type="text"
                name="name"
                className="form-input"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">{print_lang('admin.status', 'Status')}</label>
              <select
                name="status"
                className="form-select"
                value={formData.status}
                onChange={handleChange}
                disabled={admin.admin_id === 1}
              >
                <option value="active">{print_lang('common.active', 'Active')}</option>
                <option value="pending">{print_lang('common.pending', 'Pending')}</option>
                <option value="inactive">{print_lang('common.inactive', 'Inactive')}</option>
              </select>
              {admin.admin_id === 1 && (
                <small style={{ color: '#6b7280', fontSize: '0.75rem' }}>Super Admin status cannot be changed</small>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">{print_lang('admin.licenseExpiry', 'License Expiry')}</label>
              <input
                type="date"
                name="license_expired"
                className="form-input"
                value={formData.license_expired}
                onChange={handleChange}
              />
            </div>

            <div style={{ backgroundColor: '#f9fafb', padding: '1rem', borderRadius: '0.5rem', marginTop: '1rem' }}>
              <h4 style={{ fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>Account Info</h4>
              <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                <p><strong>Admin ID:</strong> {admin.admin_id}</p>
                <p><strong>Email Verified:</strong> {admin.email_verified ? 'Yes' : 'No'}</p>
                <p><strong>Created:</strong> {formatDate(admin.created_at)}</p>
                {admin.last_login && <p><strong>Last Login:</strong> {formatDate(admin.last_login)}</p>}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              {print_lang('common.cancel', 'Cancel')}
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? print_lang('common.loading', 'Loading...') : print_lang('common.save', 'Save')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminForm;
